import { RouteObject } from 'react-router-dom';
import {
  DatasetCohort,
  DatasetOverview,
  ErrorBoundary,
  GroupRoute,
  Highlights,
  SubjectCharacteristics,
} from 'src/components';
import { DatasetCodes } from 'src/components/dataset-codes/dataset-codes';
import { DataSetsList } from 'src/components/datasets-list/datasets-list';
import { AuditLog } from '../audit-page';
import { UserGroup } from 'src/types/users';
import { MainRouteV2 } from '../main-routev2';
import { CodeDetailsPage } from './code-details.page';
import { CohortDetailsPage } from './cohort-details-page';
import { DataSetsDetailsPage } from './data-details-page';
import { DataPage } from './data-page';

export const dataRouter: RouteObject[] = [
  {
    path: 'data',
    element: (
      <GroupRoute
        groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
        component={<MainRouteV2 component={<DataPage />} title="data" />}
      />
    ),
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: 'datasets',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<DataSetsList />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: 'cohorts',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<DatasetCohort />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: 'codes',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<DatasetCodes />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
    ],
  },
  {
    path: 'data/datasets/:datasetId',
    element: (
      <GroupRoute
        groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
        component={<DataSetsDetailsPage />}
      />
    ),
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: 'overview',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<DatasetOverview />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: 'subject-characteristics',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<SubjectCharacteristics />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: 'highlights',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<Highlights />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: 'cohorts',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<DatasetCohort />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: 'codes',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
            component={<DatasetCodes />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
      {
        path: 'audit-log',
        element: (
          <GroupRoute
            groupsPermitted={[UserGroup.ADMIN]}
            component={<AuditLog />}
          />
        ),
        errorElement: <ErrorBoundary />,
      },
    ],
  },
  {
    path: 'data/:dataSourceId/cohort/:cohortId',
    element: (
      <GroupRoute
        groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
        component={<CohortDetailsPage />}
      />
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: 'data/codes/:codesetId',
    element: (
      <GroupRoute
        groupsPermitted={[UserGroup.RESEARCHER, UserGroup.ADMIN]}
        component={<CodeDetailsPage />}
      />
    ),
    errorElement: <ErrorBoundary />,
  },
];
